module.exports = __webpack_public_path__ + "static/media/overview.0939e0bd.svg";